import React from 'react'
import { Whisper, Popover } from 'rsuite'
import RemindMeOutlineIcon from '@rsuite/icons/RemindOutline'

const FormFieldErrorIcon = ({ errorMessage }) => {
    return (
        <Whisper
            trigger={'click'}
            speaker={
                <Popover className="custom-popover"
                    style={{
                        color: '#DC143C', maxWidth: '200px', color: '#000',
                        background: '#CACACA',
                        '--rs-bg-overlay': '#CACACA'
                    }}
                >
                    <div>{errorMessage}</div>
                </Popover>
            }
            placement={'auto'}
        >
            <RemindMeOutlineIcon className='remind-icon' />
        </Whisper>
    )
}

export default FormFieldErrorIcon
